import { render, staticRenderFns } from "./recent.vue?vue&type=template&id=659ff9cd&"
import script from "./recent.vue?vue&type=script&lang=js&"
export * from "./recent.vue?vue&type=script&lang=js&"
import style0 from "./recent.vue?vue&type=style&index=0&id=659ff9cd&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports